import {useSelector} from '../../store.js'
import {
  PRODUCT_DETAIL_BOM_PANEL,
  PRODUCT_DETAIL_KITTING_PANEL,
  PRODUCT_SINGLE_URI_COMPONENT,
} from '../../common/constants/Products.js'
import LinkButton from '../../common/components/Link/LinkButton.js'
import {
  directBOMParentsHaveLoadedSelector,
  directBOMParentsSelector,
  directKitParentsHaveLoadedSelector,
  directKitParentsSelector,
} from '../../data/directParents.js'
import {skuSelector} from './productDetailSelectors.js'

export default function ParentsPanel({type = 'product'}) {
  const sku = useSelector(skuSelector)
  const directParentsHaveLoaded = useSelector((state) =>
    type === 'bom'
      ? directBOMParentsHaveLoadedSelector(state, {sku})
      : directKitParentsHaveLoadedSelector(state, {sku}),
  )
  const directParents = useSelector((state) =>
    type === 'bom'
      ? directBOMParentsSelector(state, {sku})
      : directKitParentsSelector(state, {sku}),
  )

  return (
    <dl className="list">
      <dt className="list__title fs-01 lh-md">
        {type === 'bom' ? 'BOM' : 'Kit'} Component Info
      </dt>

      {!directParentsHaveLoaded ? (
        <dd className="list__item fs-00 margin-top-10">
          <div className="loading">
            <span className="spinner--sm v-align-middle" />
            <span className="inline-block v-align-middle fs-00 op-75 margin-left-5">
              Loading...
            </span>
          </div>
        </dd>
      ) : directParents.length === 0 ? (
        <dd className="list__item fs-00 margin-top-10">
          This product is not a component of any parent{' '}
          {type === 'bom' ? 'BOMs' : 'kits'}.
        </dd>
      ) : (
        <>
          <dd className="list__item fs-00 margin-top-10">
            This product is a component of <span>{directParents.length}</span>{' '}
            {type === 'bom' ? 'BOM' : 'kit'} parent
            {directParents.length === 1 ? '' : 's'}:
          </dd>

          <dd className="list__item margin-top-15">
            <ul className="list list--square">
              {directParents.map(({id, name, quantityInParent}) => (
                <li className="list__item fs-00" key={id}>
                  <LinkButton
                    href={`#/${PRODUCT_SINGLE_URI_COMPONENT}/${encodeURIComponent(
                      id,
                    )}/${type === 'bom' ? PRODUCT_DETAIL_BOM_PANEL : PRODUCT_DETAIL_KITTING_PANEL}`}
                    className="darker v-align-top"
                  >
                    {name} ({quantityInParent})
                  </LinkButton>
                </li>
              ))}
            </ul>
          </dd>
        </>
      )}
    </dl>
  )
}
